import { AvatarWithFallback } from "@/components/ui/Avatar";
import { Button } from "@/components/ui/Button";
import {
  DialogClose,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/Dialog";
import { Separator } from "@/components/ui/Separator";
import { motion } from "framer-motion";
import { AlertCircle } from "lucide-react";
import Image from "next/image";
import Link from "next/link";
import { useTranslation } from "react-i18next";
import { FaMapMarkerAlt } from "react-icons/fa";
import { FaPhone } from "react-icons/fa6";

const Congratulations = ({ nearestGros }) => {
  const { t } = useTranslation("register");
  const grosLocationInMap = `https://www.google.com/maps?q=${nearestGros.latitude},${nearestGros.longitude}`;

  return (
    <>
      <DialogHeader className="sm:text-right">
        <DialogTitle className="text-foreground text-center">
          {t("register_success")}
        </DialogTitle>
      </DialogHeader>

      <div className="flex flex-col gap-4 text-foreground">
        <motion.div
          initial={{ scale: 0, opacity: 0 }}
          animate={{ scale: [0, 1], opacity: 1 }}
          transition={{ duration: 0.6, ease: "easeOut" }}
          className="text-center"
        >
          <Image
            width={170}
            height={170}
            src="/firework.png"
            alt="firework"
            objectFit="contain"
          />
        </motion.div>

        <div className="flex items-center gap-2 mt-2">
          <Separator />
          <span className="text-muted-foreground">{t("contact_vendor")}</span>
          <Separator />
        </div>

        <div className="flex flex-col items-center">
          <AvatarWithFallback
            className="w-24 h-24 text-3xl"
            src={nearestGros.avatar}
            alt={nearestGros.username}
            fallback={nearestGros.username?.slice(0, 2)}
          />

          <h5 className="font-medium mt-2">{nearestGros.username}</h5>
          <span className="text-sm text-muted-foreground">
            {nearestGros.email}
          </span>

          <Link href={"tel:" + nearestGros.phone} passHref>
            <Button variant="outline" size="sm" className="mt-2">
              <FaPhone />
              {nearestGros.phone}
            </Button>
          </Link>

          <a href={grosLocationInMap} rel="noreferrer" target="_blank">
            <Button variant="outline" size="sm" className="mt-2">
              <FaMapMarkerAlt />
              {t("vendor_location")}
            </Button>
          </a>

          <div className="mt-2 text-center p-2 bg-muted text-foreground border-2 border-border rounded-md flex items-center gap-2 justify-center">
            <AlertCircle className="h-4 w-4" />
            <span className="text-sm font-medium">
              {t("vendor_phone_save_note")}
            </span>
          </div>
        </div>

        <div className="flex items-center gap-2 mt-2">
          <Separator />
          <span className="text-muted-foreground">{t("contact_us")}</span>
          <Separator />
        </div>

        <Link href="tel:0665044458" passHref>
          <Button variant="outline" size="sm" className="w-fit mx-auto">
            <FaPhone />
            0665044458
          </Button>
        </Link>
      </div>

      <DialogFooter className="!flex-col-reverse">
        <DialogClose asChild>
          <Button className="text-foreground w-full" variant="outline">
            {t("close_button")}
          </Button>
        </DialogClose>
        <Link href="/login" passHref>
          <Button type="button" className="w-full">
            {t("login_button")}
          </Button>
        </Link>
      </DialogFooter>
    </>
  );
};

export default Congratulations;
